import { useState, useEffect } from 'react';
import { api } from '../api';
// Related jobs hook — a JobDetailView-hez kapcsolódó "Kapcsolódó állások" blokk.
// A cancelled flag védi a hookot a unmount-utáni setState warning ellen
// (race condition pl. gyors job-navigáció esetén).
export function useRelatedJobs(slug, enabled) {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!enabled || !slug) {
            setJobs([]);
            setLoading(false);
            return;
        }
        let cancelled = false;
        setLoading(true);
        setError(null);
        api.relatedJobs(slug)
            .then(r => { if (!cancelled)
            setJobs(r.jobs || []); })
            .catch(err => { if (!cancelled)
            setError(err.message); })
            .finally(() => { if (!cancelled)
            setLoading(false); });
        return () => { cancelled = true; };
    }, [slug, enabled]);
    return { jobs, loading, error };
}
